import styled from 'styled-components'
import PropTypes from 'prop-types'

import ResourceData from '../../game/Resource'
import images from '../Images'

const VerticalCenteredContainer = styled.div`
    display: flex;
    align-items: center;
`

const FittingIcon = styled.img`
    height: 100%;
`

const CountNumber = styled.span`
    padding: 0 1em;
`

function ResourceCounter({ resource }) {
    const img = images.get(resource.type)

    return(
        <VerticalCenteredContainer>
            <FittingIcon src={img.src} alt={img.alt} />
            <CountNumber>{resource.amount}</CountNumber>
        </VerticalCenteredContainer>
    )
}

ResourceCounter.propTypes = {
    resource: PropTypes.instanceOf(ResourceData)
}

export default ResourceCounter